<template>
    <div>
        <div>
            <span>
                姓名
                <el-tooltip effect="dark" content="双击修改" placement="top">
                    <i class="el-icon-question pos-icon"></i>
                </el-tooltip>
            </span>
            <span>:</span>
        </div>
        <el-checkbox-group v-model="checkList" class="m-p-c">
            <el-checkbox label="复选框 A"></el-checkbox>
        </el-checkbox-group>
    </div>
</template>

<script>
export default {
    name: 'MarkPosition',
    props: {

    },
    data() {
        return {
            checkList: [],
        }
    },
    methods: {

    },
    mounted() {
        console.log(111)
    }
}
</script>

<style scoped>
.m-p-c .wrapper .el-checkbox {
    text-align: left;
}
</style>


// WEBPACK FOOTER //
// src/pages/cloudClue/Components/MarkPosition.vue